(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/animations.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/animations.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const SUNFEATHER = {
  NUMBER_OF_TICKETs: 31,
  INTRO_DELAY: 0.03,
  FEATHER_DEG: 200,
  INTRO_DURATION: 1.5,
  SELECT_DURATION: 1.5,
  SPREAD_DURATION: 0.2,
  OUTRO_DURATION: [2.5, 1],
  getPosition: (el, nr) => {
    const degPerTicket = SUNFEATHER.FEATHER_DEG / SUNFEATHER.NUMBER_OF_TICKETs;
    const rotation = degPerTicket * nr - SUNFEATHER.FEATHER_DEG / 2 - degPerTicket / 2;
    const x = (nr - 1) * el.clientWidth / SUNFEATHER.NUMBER_OF_TICKETs - el.clientWidth / 2;
    const zIndex = SUNFEATHER.NUMBER_OF_TICKETs - nr;
    return {
      x,
      rotation,
      zIndex,
      scale: 1
    };
  }
};
const WHEEL = {
  NUMBER_OF_TICKETS: 31,
  OUTRO_DURATION: [1]
};
setGlobal('svs.tickets.play.utils.animations', {
  sunfeather: _objectSpread({
    intro: {
      default: (ref, tl, nr) => {
        tl.fromTo(ref.current, {
          scale: 1
        }, _objectSpread(_objectSpread({}, SUNFEATHER.getPosition(ref.current, nr)), {}, {
          ease: Elastic.easeOut,
          transformOrigin: '50% 100%',
          duration: SUNFEATHER.INTRO_DURATION
        }), "gameReady+=".concat(nr % 16 * SUNFEATHER.INTRO_DELAY));
      },
      tesla: (ref, tl, nr) => {
        if (document.visibilityState === 'visible') {
          const widgetHeight = 142;
          const sunfeatherContainer = document.querySelector('.sunfeather-container');
          const heightTop = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--totalTopContentHeight').split('px')[0], 10);
          const aspectRatio = 0.607;
          const yOffset = 300 + heightTop;
          const fromY = Math.max((window.innerHeight - sunfeatherContainer.clientHeight) * aspectRatio - yOffset, -50);
          const fromX = window.innerHeight * 0.25;
          tl.fromTo(ref.current, {
            x: fromX,
            y: fromY - widgetHeight,
            scale: 0
          }, _objectSpread(_objectSpread({}, SUNFEATHER.getPosition(ref.current, nr)), {}, {
            y: 0,
            duration: 1.5,
            ease: 'back.out(1.7)',
            transformOrigin: '50% 100%'
          }), "gameReady+=".concat(nr * SUNFEATHER.INTRO_DELAY));
          if (nr === 1) {
            const main = document.querySelector('main');
            const container = document.createElement('div');
            container.classList.add('main-temp-bg');
            main.classList.add('relative');
            main.appendChild(container);
            tl.to(container, 2, {
              opacity: 0,
              onComplete: () => container.remove()
            }, "gameReady+=".concat(nr * SUNFEATHER.INTRO_DELAY + 1.5));
            return () => {
              container.remove();
            };
          }
        } else {
          svs.tickets.play.utils.animations.sunfeather.intro.default(ref, tl, nr);
        }
      }
    },
    select: {
      default: function (ref) {
        let tl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gsap;
        const offSetY = ref.current.clientWidth / 2 + 6;
        return tl.to(ref.current, SUNFEATHER.SELECT_DURATION, {
          x: "0px",
          y: "".concat(offSetY, "px"),
          scale: 1.2,
          rotation: 0,
          zIndex: 32,
          ease: 'elastic.out(1, 0.3)',
          transformOrigin: '50% 100%'
        }, "gameReady+=".concat(SUNFEATHER.NUMBER_OF_TICKETs * SUNFEATHER.INTRO_DELAY));
      },
      tesla: function (ref) {
        let tl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gsap;
        const offSetY = ref.current.clientWidth / 2 + 6;
        return tl.to(ref.current, SUNFEATHER.SELECT_DURATION, {
          x: "0px",
          y: "".concat(offSetY, "px"),
          scale: 1.2,
          rotation: 0,
          zIndex: 32,
          ease: 'elastic.out(1, 0.3)',
          transformOrigin: '50% 100%'
        }, "gameReady+=".concat(SUNFEATHER.NUMBER_OF_TICKETs * SUNFEATHER.INTRO_DELAY));
      }
    },
    mouseEnter: {
      default: (ref, nr) => {
        const {
          rotation,
          x
        } = SUNFEATHER.getPosition(ref.current, nr);
        gsap.to(ref.current, SUNFEATHER.SPREAD_DURATION, {
          y: "".concat(Math.sin(Math.PI / 180 * (rotation - 90)) * 30, "px"),
          x: "".concat(Math.cos(Math.PI / 180 * (rotation - 90)) * 30 + x, "px")
        });
      }
    },
    sibblingEnter: {
      default: (ref, hoverState, nr) => {
        const {
          rotation,
          x
        } = SUNFEATHER.getPosition(ref.current, nr);
        gsap.to(ref.current, SUNFEATHER.SPREAD_DURATION, {
          y: 0,
          x,
          rotation: rotation + hoverState * 5
        });
      }
    },
    mouseLeave: {
      default: (ref, nr) => {
        gsap.to(ref.current, SUNFEATHER.SPREAD_DURATION, _objectSpread({
          y: 0
        }, SUNFEATHER.getPosition(ref.current, nr)));
      }
    },
    outro: {
      default: ref => {
        const tl = gsap.timeline();
        tl.to(ref.current, SUNFEATHER.OUTRO_DURATION[0], {
          x: 0,
          y: ref.current.clientHeight / 2,
          rotation: 0,
          ease: 'elastic.out(1, 0.3)'
        });
        tl.to(ref.current, SUNFEATHER.OUTRO_DURATION[1], {
          scale: 0,
          ease: 'back.in(2)'
        }, '-=0.5');
      }
    }
  }, SUNFEATHER),
  wheel: _objectSpread({
    intro: {
      default: (ref, tl, nr, chosen) => {
        if (chosen) {
          gsap.set(ref.current, {
            scale: 1
          });
          const container = document.querySelector('.ticket-wheel-container');
          tl.add(() => {
            if (ref.current) {
              container.scrollTo({
                left: ref.current.parentElement.offsetLeft - ref.current.clientWidth / 4,
                behavior: 'smooth'
              });
            }
          }, "gameReady");
        } else {
          gsap.set(ref.current, {
            scale: 0.9
          });
        }
      },
      tesla: (ref, tl, nr, chosen) => {
        const widgetHeight = 90;
        const xOrigin = (ref.current.clientWidth + 12) * -(nr - 1);
        const inDelay = (WHEEL.NUMBER_OF_TICKETS - nr) * 0.04;
        const outDelay = (WHEEL.NUMBER_OF_TICKETS - nr) * 0.01 + 2;
        tl.fromTo(ref.current, {
          x: xOrigin + 150,
          y: -widgetHeight,
          scale: 0
        }, {
          x: xOrigin - 600,
          y: 0,
          scale: 0.3,
          duration: 2
        }, "gameReady+=".concat(inDelay));
        tl.to(ref.current, 1.5, {
          x: 0,
          y: 0,
          scale: chosen ? 1 : 0.9
        }, "gameReady+=".concat(outDelay));
        if (nr === 1) {
          const main = document.querySelector('main');
          const container = document.createElement('div');
          container.classList.add('main-temp-bg');
          main.classList.add('relative');
          main.prepend(container);
          tl.to(container, 2, {
            opacity: 0,
            onComplete: () => container.remove()
          }, "gameReady+=".concat(nr * SUNFEATHER.INTRO_DELAY + 1.5));
          return () => {
            container.remove();
          };
        }
        if (chosen) {
          const container = document.querySelector('.ticket-wheel-container');
          tl.add(() => {
            if (ref.current) {
              container.scrollTo({
                left: ref.current.parentElement.offsetLeft - ref.current.clientWidth / 4,
                behavior: 'smooth'
              });
            }
          }, "gameReady+=".concat(4));
        }
      }
    },
    select: {
      default: function (ref) {
        let tl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gsap;
        tl.to(ref.current, 0.25, {
          scale: 1
        }, 'introDone');
      }
    },
    deSelect: {
      default: function (ref) {
        let tl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : gsap;
        tl.to(ref.current, 0.25, {
          scale: 0.9
        });
      }
    },
    outro: {
      default: ref => {
        gsap.to(ref.current, WHEEL.OUTRO_DURATION[0], {
          scale: 0.01,
          ease: 'back.in(1.7)'
        });
      }
    }
  }, WHEEL)
});

 })(window);